import { apiFetch } from "./apiClient";

export function listarMovimientos(params = {}) {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            query.append(key, value);
        }
    });

    const qs = query.toString() ? `?${query.toString()}` : "";
    return apiFetch(`/api/movimientos${qs}`);
}

export function crearMovimiento(payload) {
    return apiFetch("/api/movimientos", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function actualizarMovimiento(id, payload) {
    return apiFetch(`/api/movimientos/${id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}

export function anularMovimiento(id, usuarioAnula) {
    return apiFetch(`/api/movimientos/anular/${id}`, {
        method: "PUT",
        body: JSON.stringify({ usuarioAnula }),
    });
}